<template>
  <div class="hospitalsCon">
    <span class="positioningPrompt">当前医院根据地理位置定位，如有偏差请选择更改医院</span>
    <div class="operation">
      <div class="is_bar_code" v-if="hospitalsInfo.is_bar_code == 2">
        <van-button type="primary" class="sweepCode" @click.native="onSweepCode">立即扫码查询</van-button>
        <span class="sweepCodeHint">请扫描【检查单】条形码</span>
        <div class="partition">
          <img class="bar" src="@/assets/bar.png" alt />
        </div>
        <span>或</span>
        <div class="partition" style="padding-bottom:10px;">
          <img class="bar" src="@/assets/bar.png" alt />
        </div>
      </div>
      <van-field
        class="checkCode"
        v-if="isNameSearch"
        style="margin-bottom:10px"
        v-model="name"
        placeholder="请输入姓名查询"
      />
      <van-field class="checkCode" clearable v-model="value" :placeholder="placeholders" />
    </div>
    <van-button type="primary" class="next" @click.native="onNext">下一步</van-button>

    <van-popup
      v-model="isPhonePopup"
      style="padding:0 15px 20px;width:80%;
    border-radius: 16px;"
    >
      <p style="font-weight:600;font-size:16px ">提示</p>
      <div class="code">
        <van-field
          class="codeInput"
          v-model="phoneCode"
          type="number"
          placeholder="请输入4位验证码"
          @input.native="onInputCode"
          maxlength="4"
        />
        <van-button
          class="toObtain"
          :disabled="codeBool"
          @click.native="getsendSms"
          type="default"
        >{{ innerText }}</van-button>
      </div>
      <van-button type="primary" class="next" :disabled="rules" @click="getCheckCaptcha">确定</van-button>
    </van-popup>
  </div>
</template>
<script>
import Storage from '@/tools/storage'
import { sendCode, checkSendCode } from "@/api/login";

export default {
  props: ['placeholder', 'hospitalsInfo'],
  name: '',
  data() {
    return {
      value: '',
      placeholders: '请输入' + this.placeholder + '查询',
      isPhonePopup: false,
      innerText: "获取验证码",
      codeBool: false,
      phoneCode: "",
      rules: true,
      name: "",
      isNameSearch: false
    };
  },
  methods: {
    onNext() {
      if (this.$route.query.institution_condition == 0) {
        if (this.value) {
          this.isPhonePopup = true;
        } else {
          alert("请输入查询条件");
        }
      } else {
        this.isPhonePopup = false;
        if (this.name) {
          this.goReportInfo();
        } else {
          alert("请输入查询条件");
        }
      }
    },
    goReportInfo() {
      this.$store.getters.getDemoValue;
      this.$store.commit("setDemoValue", {});
      if(this.placeholder === '身份证号'){
        if(this.value && this.value.length !== 18){
          alert('身份证位数错误')
          return
        }
      }
      let params = {
        search: this.value,
        institution_id: this.hospitalsInfo.id,
        phone: Storage.get("phone"),
        name: this.name ? this.name : undefined,
        type: 1
      };
      this.$emit("getReportInfo", params);
    },
    async getsendSms() {
      this.djsFn();
      let data = { phone: Storage.get("phone") };
      let res = await sendCode(data);
    },
    async getCheckCaptcha() {
      let data = {
        phone: Storage.get("phone"),
        code: this.phoneCode
      };
      let res = await checkSendCode(data);
      if (res) {
        this.goReportInfo();
      }
    },
    onInputCode() {
      if (this.phoneCode.length == 4 && Storage.get("phone")) {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    djsFn() {
      let timer = null;
      clearInterval(timer); //这句话至关重要
      let time = 60;
      let that = this;
      timer = setInterval(function() {
        if (time <= 0) {
          that.innerText = "";
          that.innerText = "重新获取";
          that.codeBool = false;
          clearInterval(timer);
        } else {
          that.codeBool = true;
          that.innerText = "";
          that.innerText = "剩余时间" + time + "秒";
          time--;
        }
      }, 1000);
    },
    onValidation() {
      this.goReportInfo();
    },
    onSweepCode() {
      this.$emit('getscan')
    }
  },
  created() {
    if (this.$route.query.institution_condition == 0) {
      this.isNameSearch = false;
    } else {
      this.isNameSearch = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.codeInput {
  width: 65%;
}
.van-cell--borderless::after,
.van-cell:last-child::after {
  display: block !important;
}
.code {
  display: flex;
  margin-top: 20px;
}
.toObtain {
  width: 35%;
  margin-left: 20px;
  color: rgb(19, 172, 193);
  background: #efefef;
  border: none;
  opacity: 1;
  font-size: 14px;
}
</style>
